module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.seen == 'list') ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "input-group  pull-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "34px",
      "margin-top": "12px"
    },
    attrs: {
      "type": "text",
      "name": "message",
      "placeholder": "Buscar ..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('a', {
    staticClass: "btn btn-app pull-right bg-red",
    on: {
      "click": function($event) {
        _vm.nuevo()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus "
  }), _vm._v(" Nuevo\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs pull-left"
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#tab_1",
      "data-toggle": "tab",
      "aria-expanded": "true"
    }
  }, [_vm._v("En progreso (" + _vm._s(_vm.filteredItems.length) + ")")])]), _vm._v(" "), _c('li', {}, [_c('a', {
    attrs: {
      "href": "#tab_2",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("Completo (" + _vm._s(_vm.filteredCompletos.length) + ")")])]), _vm._v(" "), _c('li', {}, [_c('a', {
    attrs: {
      "href": "#tab_3",
      "data-toggle": "tab",
      "aria-expanded": "false"
    }
  }, [_vm._v("Archivo (" + _vm._s(_vm.filteredEliminados.length) + ")")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "id": "tab_1"
    }
  }, [(_vm.filteredItems.length > 0) ? _c('paginate', {
    attrs: {
      "name": "filteredItems",
      "list": _vm.filteredItems,
      "per": 10
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Fecha Entrada")]), _vm._v(" "), _c('th', [_vm._v("Patente")]), _vm._v(" "), _c('th', [_vm._v("Operación")]), _vm._v(" "), _c('th', [_vm._v("Cliente")]), _vm._v(" "), _c('th', [_vm._v("Producto")]), _vm._v(" "), _c('th', [_vm._v("Destino/Deposito")]), _vm._v(" "), _c('th', [_vm._v("Fecha Salida")]), _vm._v(" "), _c('th', [_vm._v("Entrada (Kg)")]), _vm._v(" "), _c('th', [_vm._v("Salida (Kg)")]), _vm._v(" "), _c('th', [_vm._v("Neto (Kg)")]), _vm._v(" "), _c('th', [_vm._v(" ")]), _vm._v(" "), _c('th', [_vm._v(" ")])]), _vm._v(" "), _vm._l((_vm.paginated('filteredItems')), function(item) {
    return _c('tr', {
      key: item._id
    }, [_c('td', [_vm._v(_vm._s(new Date(item.fecha_entrada).toLocaleDateString() + ' ' + new Date(item.fecha_entrada).toLocaleTimeString()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.patente))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.tipo_operacion.charAt(0).toUpperCase() + item.tipo_operacion.slice(1)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.cliente))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.producto))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.destino))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.fecha_salida != null ? new Date(item.fecha_salida).toLocaleDateString() + ' ' + new Date(item.fecha_salida).toLocaleTimeString() : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.peso_entrada))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.peso_salida))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.peso_neto))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-block btn-primary btn-sm",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.cargar(item, 'completar')
        }
      }
    }, [_vm._v("Completar")])]), _vm._v(" "), (typeof item.asset != 'undefined') ? _c('td', [_c('i', {
      staticClass: "fas fa-sync"
    }), _vm._v("  Pendiente\n    \t\t\t                    ")]) : _c('td', [_vm._v("\n    \t\t\t                    \t \n    \t\t\t                    ")])])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('paginate-links', {
    staticClass: "pagination pull-right",
    attrs: {
      "for": "filteredItems",
      "async": true,
      "show-step-links": true,
      "limit": 4
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_2"
    }
  }, [(_vm.filteredCompletos.length > 0) ? _c('paginate', {
    attrs: {
      "name": "filteredCompletos",
      "list": _vm.filteredCompletos,
      "per": 10
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Fecha Entrada")]), _vm._v(" "), _c('th', [_vm._v("Patente")]), _vm._v(" "), _c('th', [_vm._v("Operación")]), _vm._v(" "), _c('th', [_vm._v("Cliente")]), _vm._v(" "), _c('th', [_vm._v("Producto")]), _vm._v(" "), _c('th', [_vm._v("Destino/Deposito")]), _vm._v(" "), _c('th', [_vm._v("Fecha Salida")]), _vm._v(" "), _c('th', [_vm._v("Entrada (Kg)")]), _vm._v(" "), _c('th', [_vm._v("Salida (Kg)")]), _vm._v(" "), _c('th', [_vm._v("Neto (Kg)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "min-width": "150px"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('th', [_vm._v(" ")])]), _vm._v(" "), _vm._l((_vm.paginated('filteredCompletos')), function(completo) {
    return _c('tr', {
      key: completo._id
    }, [_c('td', [_vm._v(_vm._s(new Date(completo.fecha_entrada).toLocaleDateString() + ' ' + new Date(completo.fecha_entrada).toLocaleTimeString()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(completo.patente))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(completo.tipo_operacion.charAt(0).toUpperCase() + completo.tipo_operacion.slice(1)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(completo.cliente))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(completo.producto))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(completo.destino))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(completo.fecha_salida != null ? new Date(completo.fecha_salida).toLocaleDateString() + ' ' + new Date(completo.fecha_salida).toLocaleTimeString() : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(completo.peso_entrada))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(completo.peso_salida))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(completo.peso_neto))]), _vm._v(" "), (typeof completo.asset === 'undefined') ? _c('td', {
      staticStyle: {
        "min-width": "150px"
      }
    }, [_c('button', {
      staticClass: "btn btn-block btn-primary btn-sm btn-edit",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.cargar(completo, 'editar')
        }
      }
    }, [_vm._v("Editar")]), _vm._v(" "), _c('i', {
      staticClass: "fas fa-times-circle",
      on: {
        "click": function($event) {
          _vm.remove(completo)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fas fa-print",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.pdf(completo)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (typeof completo.asset === 'undefined') ? _c('td') : _vm._e(), _vm._v(" "), (typeof completo.asset != 'undefined') ? _c('td', {
      staticStyle: {
        "min-width": "150px"
      }
    }, [_c('i', {
      staticClass: "fas fa-sync"
    }), _vm._v("  Pendiente\n    \t\t\t                    ")]) : _vm._e()])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('paginate-links', {
    staticClass: "pagination pull-right",
    attrs: {
      "for": "filteredCompletos",
      "async": true,
      "show-step-links": true,
      "limit": 4
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "tab_3"
    }
  }, [(_vm.filteredEliminados.length > 0) ? _c('paginate', {
    attrs: {
      "name": "filteredEliminados",
      "list": _vm.filteredEliminados,
      "per": 15
    }
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Fecha Entrada")]), _vm._v(" "), _c('th', [_vm._v("Patente")]), _vm._v(" "), _c('th', [_vm._v("Operación")]), _vm._v(" "), _c('th', [_vm._v("Cliente")]), _vm._v(" "), _c('th', [_vm._v("Producto")]), _vm._v(" "), _c('th', [_vm._v("Destino/Deposito")]), _vm._v(" "), _c('th', [_vm._v("Fecha Salida")]), _vm._v(" "), _c('th', [_vm._v("Entrada (Kg)")]), _vm._v(" "), _c('th', [_vm._v("Salida (Kg)")]), _vm._v(" "), _c('th', [_vm._v("Neto (Kg)")]), _vm._v(" "), _c('th', [_vm._v(" ")])]), _vm._v(" "), _vm._l((_vm.paginated('filteredEliminados')), function(eliminado) {
    return _c('tr', {
      key: eliminado._id
    }, [_c('td', [_vm._v(_vm._s(new Date(eliminado.fecha_entrada).toLocaleDateString() + ' ' + new Date(eliminado.fecha_entrada).toLocaleTimeString()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eliminado.patente))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eliminado.tipo_operacion.charAt(0).toUpperCase() + eliminado.tipo_operacion.slice(1)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eliminado.cliente))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eliminado.producto))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eliminado.destino))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eliminado.fecha_salida != null ? new Date(eliminado.fecha_salida).toLocaleDateString() + ' ' + new Date(eliminado.fecha_salida).toLocaleTimeString() : ''))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eliminado.peso_entrada))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eliminado.peso_salida))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(eliminado.peso_neto))]), _vm._v(" "), (_vm.onlineState) ? _c('td', [_c('button', {
      staticClass: "btn btn-block btn-primary btn-sm btn-edit",
      staticStyle: {
        "max-width": "84px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.desarchivar(eliminado)
        }
      }
    }, [_vm._v("Desarchivar")])]) : _vm._e()])
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('paginate-links', {
    staticClass: "pagination pull-right",
    attrs: {
      "for": "filteredEliminados",
      "async": true
    }
  })], 1)])])])])]) : _vm._e(), _vm._v(" "), (_vm.seen == 'form') ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.seen == 'form') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('a', {
    staticClass: "btn btn-app pull-right bg-red",
    on: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times "
  }), _vm._v(" Cerrar\n                ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Operación")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.tipo_operacion),
      expression: "input.tipo_operacion"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.accionForm == 'editar'
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.input, "tipo_operacion", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.formCampos()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "despacho"
    }
  }, [_vm._v("Despacho")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ingreso"
    }
  }, [_vm._v("Ingreso")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ajuste"
    }
  }, [_vm._v("Ajuste")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Producto")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.productos,
      "name": "producto",
      "selectOnTab": true
    },
    model: {
      value: (_vm.input.producto),
      callback: function($$v) {
        _vm.$set(_vm.input, "producto", $$v)
      },
      expression: "input.producto"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('producto')))])], 1)]), _vm._v(" "), (_vm.operacion == 'despacho' || _vm.operacion == 'ingreso') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Patente")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.patente),
      expression: "input.patente"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "patente",
      "onkeypress": "return alfaNumerico(event)"
    },
    domProps: {
      "value": (_vm.input.patente)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.input, "patente", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('patente')))])])]) : _vm._e(), _vm._v(" "), (_vm.operacion == 'despacho' || _vm.operacion == 'ingreso') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Chofer")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "etiqueta",
      "options": _vm.choferes,
      "taggable": "",
      "name": "chofer",
      "selectOnTab": true
    },
    model: {
      value: (_vm.input.chofer),
      callback: function($$v) {
        _vm.$set(_vm.input, "chofer", $$v)
      },
      expression: "input.chofer"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('chofer')))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.operacion == 'despacho' || _vm.operacion == 'ingreso') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Transportista")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "etiqueta",
      "options": _vm.proveedores,
      "taggable": "",
      "name": "proveedor",
      "selectOnTab": true
    },
    model: {
      value: (_vm.input.proveedor),
      callback: function($$v) {
        _vm.$set(_vm.input, "proveedor", $$v)
      },
      expression: "input.proveedor"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('proveedor')))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.operacion == 'ingreso' || _vm.operacion == 'ajuste') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Deposito")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    key: "s1",
    attrs: {
      "label": "etiqueta",
      "options": _vm.depositos,
      "taggable": "",
      "name": "deposito",
      "selectOnTab": true
    },
    model: {
      value: (_vm.input.deposito),
      callback: function($$v) {
        _vm.$set(_vm.input, "deposito", $$v)
      },
      expression: "input.deposito"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('deposito', 's1')))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.operacion == 'despacho') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Destino")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "etiqueta",
      "options": _vm.destinos,
      "taggable": "",
      "name": "destino",
      "selectOnTab": true
    },
    model: {
      value: (_vm.input.destino),
      callback: function($$v) {
        _vm.$set(_vm.input, "destino", $$v)
      },
      expression: "input.destino"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('destino')))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.operacion == 'despacho' || _vm.operacion == 'ingreso' || _vm.operacion == 'ajuste') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Operador")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "etiqueta",
      "options": _vm.operadores,
      "taggable": "",
      "name": "operador",
      "selectOnTab": true
    },
    model: {
      value: (_vm.input.operador),
      callback: function($$v) {
        _vm.$set(_vm.input, "operador", $$v)
      },
      expression: "input.operador"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('operador')))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.operacion == 'despacho' || _vm.operacion == 'ingreso') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Entrada (Kg)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.peso_entrada),
      expression: "input.peso_entrada"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "peso_entrada",
      "onkeypress": "return onlyNumbersWithDot(event)"
    },
    domProps: {
      "value": (_vm.input.peso_entrada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.input, "peso_entrada", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('peso_entrada')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.updatebtn && (_vm.operacion == 'despacho' || _vm.operacion == 'ingreso')) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Salida Kg")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.peso_salida),
      expression: "input.peso_salida"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "onkeypress": "return onlyNumbersWithDot(event)"
    },
    domProps: {
      "value": (_vm.input.peso_salida)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.input, "peso_salida", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('peso_salida')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.updatebtn && (_vm.operacion == 'despacho' || _vm.operacion == 'ingreso')) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Peso Neto Kg")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.input.peso_salida != '' || _vm.input.peso_salida != 'null' ? (_vm.input.peso_entrada - _vm.input.peso_salida) : _vm.input.peso_entrada
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.operacion == 'despacho' || _vm.operacion == 'ingreso' || _vm.operacion == 'ajuste') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Observaciones "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin": "-3px 6px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chkObservaciones),
      expression: "chkObservaciones"
    }],
    staticClass: "check",
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": true,
      "checked": Array.isArray(_vm.chkObservaciones) ? _vm._i(_vm.chkObservaciones, "1") > -1 : (_vm.chkObservaciones)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.chkObservaciones,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.chkObservaciones = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.chkObservaciones = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.chkObservaciones = $$c
        }
      }
    }
  })])]), _vm._v(" "), (_vm.chkObservaciones) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.observaciones),
      expression: "input.observaciones"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (_vm.rules),
      expression: "rules"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "name": "observaciones"
    },
    domProps: {
      "value": (_vm.input.observaciones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.input, "observaciones", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('observaciones')))])])]) : _vm._e(), _vm._v(" "), (_vm.operacion == 'ingreso') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Remito #")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.remito),
      expression: "input.remito"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "onkeypress": "positiveInt(event)"
    },
    domProps: {
      "value": (_vm.input.remito)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.input, "remito", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.operacion == 'despacho' || _vm.operacion == 'ingreso') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Bolsones")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.q_bolsones),
      expression: "input.q_bolsones"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.input.q_bolsones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.input, "q_bolsones", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.operacion == 'ingreso') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Peso Declarado")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.peso_declarado),
      expression: "input.peso_declarado"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "onkeypress": "return onlyNumbersWithDot(event)"
    },
    domProps: {
      "value": (_vm.input.peso_declarado)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.input, "peso_declarado", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.operacion == 'ajuste') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Desvio (Kg)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.desvio),
      expression: "input.desvio"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    key: "s2",
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "desvio",
      "onkeypress": "return onlyNumbersWithDot(event)"
    },
    domProps: {
      "value": (_vm.input.desvio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.input, "desvio", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('desvio', 's2')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.savebtn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.guardar()
      }
    }
  }, [_vm._v("Guardar")]) : _vm._e(), _vm._v(" "), (_vm.updatebtn) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.editar()
      }
    }
  }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.seen == 'formCompletar') ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.seen == 'form') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('a', {
    staticClass: "btn btn-app pull-right bg-red",
    on: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-times "
  }), _vm._v(" Cerrar\n                ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Completar Registro " + _vm._s(_vm.input._id))])]), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Operación: " + _vm._s(_vm.input.operacion.charAt(0).toUpperCase() + _vm.input.operacion.slice(1)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Producto")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.productos,
      "taggable": "",
      "name": "producto",
      "disabled": ""
    },
    model: {
      value: (_vm.input.producto),
      callback: function($$v) {
        _vm.$set(_vm.input, "producto", $$v)
      },
      expression: "input.producto"
    }
  })], 1)]), _vm._v(" "), (_vm.operacion == 'despacho' || _vm.operacion == 'ingreso') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Patente")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.patente),
      expression: "input.patente"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.input.patente)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.input, "patente", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.operacion == 'despacho' || _vm.operacion == 'ingreso') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Chofer")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "etiqueta",
      "options": _vm.choferes,
      "taggable": "",
      "name": "chofer",
      "disabled": ""
    },
    model: {
      value: (_vm.input.chofer),
      callback: function($$v) {
        _vm.$set(_vm.input, "chofer", $$v)
      },
      expression: "input.chofer"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.operacion == 'despacho' || _vm.operacion == 'ingreso') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Transportista")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "etiqueta",
      "options": _vm.proveedores,
      "taggable": "",
      "name": "proveedor",
      "disabled": ""
    },
    model: {
      value: (_vm.input.proveedor),
      callback: function($$v) {
        _vm.$set(_vm.input, "proveedor", $$v)
      },
      expression: "input.proveedor"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('proveedor')))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.operacion == 'ingreso') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Deposito")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "etiqueta",
      "options": _vm.depositos,
      "taggable": "",
      "name": "deposito",
      "disabled": ""
    },
    model: {
      value: (_vm.input.destino),
      callback: function($$v) {
        _vm.$set(_vm.input, "destino", $$v)
      },
      expression: "input.destino"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('deposito')))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.operacion == 'despacho' || _vm.operacion == 'ingreso' || _vm.operacion == 'ajuste') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Destino")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "etiqueta",
      "options": _vm.destinos,
      "taggable": "",
      "name": "destino",
      "disabled": ""
    },
    model: {
      value: (_vm.input.destino),
      callback: function($$v) {
        _vm.$set(_vm.input, "destino", $$v)
      },
      expression: "input.destino"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('destino')))])], 1)]) : _vm._e(), _vm._v(" "), (_vm.operacion == 'despacho' || _vm.operacion == 'ingreso' || _vm.operacion == 'ajuste') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Operador")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "etiqueta",
      "options": _vm.operadores,
      "taggable": "",
      "name": "operador",
      "disabled": ""
    },
    model: {
      value: (_vm.input.operador),
      callback: function($$v) {
        _vm.$set(_vm.input, "operador", $$v)
      },
      expression: "input.operador"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.operacion == 'despacho' || _vm.operacion == 'ingreso' || _vm.operacion == 'ajuste') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Observaciones "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin": "-3px 6px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chkObservaciones),
      expression: "chkObservaciones"
    }],
    staticClass: "check",
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.chkObservaciones) ? _vm._i(_vm.chkObservaciones, "1") > -1 : (_vm.chkObservaciones)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.chkObservaciones,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.chkObservaciones = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.chkObservaciones = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.chkObservaciones = $$c
        }
      }
    }
  })])]), _vm._v(" "), (_vm.chkObservaciones) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.observaciones),
      expression: "input.observaciones"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.input.observaciones)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.input, "observaciones", $event.target.value)
      }
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.operacion == 'despacho' || _vm.operacion == 'ingreso') ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Entrada Kg")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.peso_entrada),
      expression: "input.peso_entrada"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.input.peso_entrada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.input, "peso_entrada", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Salida Kg")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.input.peso_salida),
      expression: "input.peso_salida"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "onkeypress": "return onlyNumbersWithDot(event)"
    },
    domProps: {
      "value": (_vm.input.peso_salida)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.input, "peso_salida", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('peso_salida')))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Peso Neto Kg")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.input.peso_salida != '' || _vm.input.peso_salida != 'null' ? (_vm.input.peso_entrada - _vm.input.peso_salida) : _vm.input.peso_entrada
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.completar()
      }
    }
  }, [_vm._v("Guardar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.cancelar()
      }
    }
  }, [_vm._v("Cancelar")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "right": "2200px"
    }
  }, [_c('table', {
    attrs: {
      "id": "html-2-pdfwrapper"
    }
  }, [_c('tbody', [_vm._m(1), _vm._v(" "), _c('tr', [_c('td', [_vm._v("GUIA DE DESPACHO"), _c('br'), _vm._v(" Fecha:\n\t\t\t\t\t\t" + _vm._s(_vm.pdfData.fecha_salida)), _c('br'), _vm._v(" Transaccion ID:\n\t\t\t\t\t\t" + _vm._s(_vm.pdfData._id) + "\n\t\t\t\t\t")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cliente: " + _vm._s(_vm.pdfData.cliente) + " "), _c('br'), _vm._v(" Proyecto:\n\t\t\t\t\t\t" + _vm._s(_vm.pdfData.proyecto) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Destino: " + _vm._s(_vm.pdfData.destino))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Detalle "), _c('br'), _vm._v("\n\t\t\t\t\t     Item       Cantidad       Unidad Medida       Descripción                   Bolsones "), _c('br'), _vm._v(" \n\t\t\t\t\t     01      " + _vm._s(_vm.pdfData.peso_neto) + "   Kg.   " + _vm._s(_vm.pdfData.producto) + "   " + _vm._s(_vm.pdfData.q_bolsones) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Transportista")]), _vm._v(" "), _c('br'), _vm._v(" Empresa:\n\t\t\t\t\t\t" + _vm._s(_vm.pdfData.proveedor) + " "), _c('br'), _vm._v(" Chofer: " + _vm._s(_vm.pdfData.chofer) + "\n\t\t\t\t\t\t"), _c('br'), _vm._v("Patente: " + _vm._s(_vm.pdfData.patente))])]), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('table', {
    attrs: {
      "id": "tabla-copia"
    }
  }, [_c('tbody', [_vm._m(5), _vm._v(" "), _c('tr', [_c('td', [_vm._v("GUIA DE DESPACHO"), _c('br'), _vm._v(" Fecha:\n\t\t\t\t\t\t" + _vm._s(_vm.pdfData.fecha_salida)), _c('br'), _vm._v(" Transaccion ID:\n\t\t\t\t\t\t" + _vm._s(_vm.pdfData._id) + "\n\t\t\t\t\t")])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Cliente: " + _vm._s(_vm.pdfData.cliente) + " "), _c('br'), _vm._v(" Proyecto:\n\t\t\t\t\t\t" + _vm._s(_vm.pdfData.proyecto) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Destino: " + _vm._s(_vm.pdfData.destino))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Detalle "), _c('br'), _vm._v("\n\t\t\t\t\t     Item       Cantidad       Unidad Medida       Descripción                   Bolsones "), _c('br'), _vm._v(" \n\t\t\t\t\t     01      " + _vm._s(_vm.pdfData.peso_neto) + "   Kg.   " + _vm._s(_vm.pdfData.producto) + "   " + _vm._s(_vm.pdfData.q_bolsones) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Transportista")]), _vm._v(" "), _c('br'), _vm._v(" Empresa:\n\t\t\t\t\t\t" + _vm._s(_vm.pdfData.proveedor) + " "), _c('br'), _vm._v(" Chofer: " + _vm._s(_vm.pdfData.chofer) + "\n\t\t\t\t\t\t"), _c('br'), _vm._v("Patente: " + _vm._s(_vm.pdfData.patente))])]), _vm._v(" "), _vm._m(7)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Nuevo Registro")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Logistica de Arenas de Fractura "), _c('br'), _vm._v(" Ingenieria Sima S.A. - Parque Industrial Añelo - Cruce Rutas 7 y 17 - Neuquen \n\t\t\t\t\t"), _c('br'), _vm._v(" Tel: (0299) 440999 Lineas Rotativas\n\t\t\t\t\t "), _c('br'), _vm._v(" Fax: (0299) 4490998 - E-Mail: info@sima.com.ar "), _c('br'), _vm._v("\n\t\t\t\t\t\tI.V.A RESPONSABLE INSCRIPTO\n\t\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("FIRMAS - SELLOS"), _c('br'), _vm._v("  "), _c('br'), _vm._v("   "), _c('br'), _vm._v("  "), _c('br'), _vm._v("   "), _c('br'), _vm._v("    \n\t\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    attrs: {
      "id": "table-lineas"
    }
  }, [_c('tr', [_c('td', [_vm._v("- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v(" ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("Logistica de Arenas de Fractura "), _c('br'), _vm._v(" Ingenieria Sima S.A. - Parque Industrial Añelo - Cruce Rutas 7 y 17 - Neuquen \n\t\t\t\t\t"), _c('br'), _vm._v(" Tel: (0299) 440999 Lineas Rotativas\n\t\t\t\t\t "), _c('br'), _vm._v(" Fax: (0299) 4490998 - E-Mail: info@sima.com.ar "), _c('br'), _vm._v("\n\t\t\t\t\t\tI.V.A RESPONSABLE INSCRIPTO\n\t\t\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("FIRMAS - SELLOS"), _c('br'), _vm._v("  "), _c('br'), _vm._v("   "), _c('br'), _vm._v("  "), _c('br'), _vm._v("   "), _c('br'), _vm._v("    \n\t\t\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d280fda"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Movimiento.vue
// module id = 1055
// module chunks = 1